module.exports = __webpack_public_path__ + "img/add-vendor.3a315434.svg";